import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static values = { closeOnBackdropClick: { type: Boolean, default: true } }

  connect() {
    this.isShown = false
    this.isClosing = false
    $(this.element).one('shown.bs.modal', () => { this.isShown = true })

    // There is something weird going on here with some modals closing with the escape key
    // and some not. They seem to ignore the keyboard: false option, but also some only work due to the
    // handleKeyup function below.
    // We definitely want to prevent accidental closing of the new post modal.
    $(this.element).modal({ keyboard: false, show: true, backdrop: 'static' });
    useClickOutside(this, { element: this.element.getElementsByClassName("modal-content")[0] });

    setTimeout(() => {
      this.stackNestedModals()
      this.refreshSelect2Widths()
    }, 200)

    // Close the modal when a link is clicked that is targetted to modal _top
    this.element.addEventListener('click', this.linkClicked.bind(this))

    // Focus the first element with the autofocus attribute when the modal is shown
    $(this.element).on('shown.bs.modal', function (e) {
      let modal = e.currentTarget;
      modal.querySelector('[autofocus]')?.focus();
    })
  }

  disconnect() {
    // The modal overlay doesn't fade out in time when navigating away from the page
    // This means that it is cached by turbo and re-appears when navigating back to the page
    // This is a hacky way to prevent that as it only occurs when the modal has a fade animation
    $(this.element).removeClass('fade')
    this.close()
  }

  linkClicked(e) {
    if ((e.target instanceof HTMLAnchorElement) && e.target.dataset.turboFrame == "_top") {
      this.disconnect()
    }
  }

  clickOutside(event) {
    // Click outside is targetted to the modal-content element while this.element is the modal container which covers the whole screen
    // This means that the modal will close when clicking outside of the modal-content but still inside the modal container
    // This prevents the modal closing when clicking on 'outside' elements like datepickers which are appended to the body
    if (this.closeOnBackdropClickValue && event.target === this.element) {
      this.close()
    }
  }

  close() {
    if (this.isClosing) return
    this.isClosing = true

    const modal = $(this.element)
    // Let Bootstrap remove its backdrop and restore the body before detaching the modal.
    modal.one('hidden.bs.modal', () => {
      modal.modal('dispose')
      this.element.remove()
    })

    // Prevent turbo re-opening the modal on restoration

    // Find the closest ancestor that matches the selector "turbo-frame"
    const turboFrame = this.element.closest("turbo-frame");
    if (turboFrame !== null) { turboFrame.src = undefined; }

    // Bootstrap ignores hide requests while the opening transition is running.
    if (this.isShown) {
      modal.modal('hide')
    } else {
      modal.one('shown.bs.modal', () => { modal.modal('hide') })
    }
  }

  handleKeyup(e) {
    if (e.code == "Escape") {
      this.close()
    }
  }

  handleSubmit(e) {
    if (e.detail.success && e.detail.formSubmission.submitter) {
      this.close()
    }
  }

  // Bootstrap does not support nested modals, so we need to handle stacking
  // Set z-indices and overlay the modal backdrop so that nested modals appear on top of each other
  stackNestedModals() {
    var numVisibleModals = $('.modal:visible').length
    if (numVisibleModals) {
      var lastZIndex = 0
      for (var i = 0; i < numVisibleModals; i++) {
        let el = $('.modal:visible')[i];
        let zIndex = 1000 + (10 * (i + 1));
        document.getElementById(el.id).style.zIndex = zIndex;
        lastZIndex = zIndex;
      }
      $('.modal-backdrop').not('.modal-stack').css('z-index', lastZIndex - 1).addClass('modal-stack');
    }
  }

  // Refresh the widths of select2 elements within the modal to ensure proper
  // display This is because placeholders sometimes get hidden as the input box
  // is calculated as 0 at initialize time, which is when the modal is still
  // hidden.
  refreshSelect2Widths() {
    const selectElements = this.element.querySelectorAll("select[data-controller~='select2'], select[data-controller~='select2-tokenfield']");
    selectElements.forEach((select) => {
      const instance = $(select).data("select2");
      const selection = instance?.selection;
      const resizeSearch = selection?.resizeSearch;
      if (typeof resizeSearch === "function") {
        resizeSearch.call(selection);
      }
    });
  }
}
